/**
 * 微信js-sdk
 * 参考文档：https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import wx from 'weixin-js-sdk';

//接口调用文件
import index from '@/api/index';
//接口配置文件
import { Api } from '@/api/api';

/**微信分享
 * @param {Object} option
 * {title:'',link:location.href.split('#')[0],imgUrl:'',desc:''}
 */
const wxShare = function () {
  let that = this;
  let ret = index
    .fetchData_post(Api.lanmor.getsign, {
      url: window.location.href,
    })
    .then((res) => {
      if (res.success) {
        wx.config({
          debug: false, // 开启调试模式
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ['openLocation', 'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2,
          openTagList: ['wx-open-launch-weapp'],
        });
        wx.ready(function () {
          // localStorage.setItem('wx_appId', res.data.appId ? res.data.appId : '');
          // localStorage.setItem('wx_username', res.data.username ? res.data.username : '');
          // localStorage.setItem('wx_path', res.data.path ? res.data.path : '');
          localStorage.setItem('wx_appId', 'wxbc6691f0b4a022a8');
          localStorage.setItem('wx_username', 'gh_88e90324eea5');
          localStorage.setItem('wx_path', 'pages/index/index.html');
          wx.onMenuShareTimeline({
            title: res.data.title, // 分享标题
            link: res.data.url, // 分享链接
            imgUrl: res.data.image, // 分享图标
            desc: res.data.memo, // 分享描述
            success() {
              // 用户成功分享后执行的回调函数
            },
            cancel() {
              // 用户取消分享后执行的回调函数
            },
          });
          wx.onMenuShareAppMessage({
            title: res.data.title, // 分享标题
            link: res.data.url, // 分享链接
            imgUrl: res.data.image, // 分享图标
            desc: res.data.memo, // 分享描述
            success() {
              // 用户成功分享后执行的回调函数
            },
            cancel() {
              // 用户取消分享后执行的回调函数
            },
          });
        });
      }
    })
    .catch(() => {});
};

export default wxShare;
